import React, { useRef } from "react";
import { motion, Variants, useInView } from "framer-motion";

export interface FadeInOnScrollProps {
  children: React.ReactNode;
  className?: string;
  /** 시작 시 아래에서 위로 올라오는 거리(px). 기본값 30 */
  y?: number;
  /** 애니메이션 지속 시간(s). 기본값 0.6 */
  duration?: number;
  /** 지연 시간(s). 기본값 0 */
  delay?: number;
  /** 뷰포트에 들어올 때만 1회 실행할지 여부. 기본값 false (진입/이탈 시 반복) */
  once?: boolean;
  /** 요소가 보였다고 판단할 비율(0~1). 기본값 0.3 */
  amount?: number;
}

const FadeInOnScroll: React.FC<FadeInOnScrollProps> = ({
  children,
  className,
  y = 30,
  duration = 0.6,
  delay = 0,
  once = false,
  amount = 0.3,
}) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const inView = useInView(ref, { amount, once });

  const variants: Variants = {
    hidden: { opacity: 0, y },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={inView ? "visible" : "hidden"}
      variants={variants}
      transition={{ duration, ease: "easeOut", delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

export default FadeInOnScroll;

